import React, { useState, useEffect, useMemo } from 'react'
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import { SurfaceCard, PageHeader } from '../../Components/Ui'
import { Select } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder/lib';
import CalificationForm from './CalificationForm';
import BitacoraForm from './BitacoraForm';
import HistoryBitacora from './HistoryBitacora';

const actionTile = (active) => ({
    background: active ? '#201030' : '#F9FAFB',
    color: active ? '#fff' : '#201030',
    border: `1px solid ${active ? '#201030' : '#E5E7EB'}`,
    borderRadius: 12,
    padding: '14px 16px',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '0.85rem',
    letterSpacing: '0.04em',
    cursor: 'pointer',
    transition: 'background 0.15s ease, color 0.15s ease'
})

const Evaluation = () => {
    const [ready, setReady] = useState(false)
    const [branchOffices, setBranchOffices] = useState([])
    const [branchOfficeSelected, setBranchOfficeSelected] = useState('')
    const [customerSelected, setCustomerSelected] = useState('')
    const [customers, setCustomers] = useState([])

    useEffect(() => {
        Controllers.branch_office.get_branch_office().then(res => {
            setBranchOffices(res.data.filter(b => parseInt(b.state_branch_office) === 1))
            setReady(true)
        })
    }, [])

    const [titleCalification, setTitleCalification] = useState('')

    useEffect(() => {
        if (branchOfficeSelected !== '') {
            setCustomers([])
            Controllers.customers.get_customers_branch_office({
                p_id_branch_office: branchOfficeSelected.value
            }).then(res => {
                setCustomers(res.data)
            })
        }
    }, [branchOfficeSelected])

    const [typeForm, setTypeForm] = useState(null)

    const formAction = useMemo(() => {
        if (typeForm === null) {
            return ''
        }
        if (typeForm === 1) {
            setTitleCalification('Calificar Empleado')
            return <CalificationForm idCustomers={customerSelected.value} onSuccess={() => setTypeForm(null)} />
        }
        if (typeForm === 2) {
            setTitleCalification('Bitácora del Desempeño')
            return <BitacoraForm idCustomers={customerSelected.value} onSuccess={() => setTypeForm(null)} />
        }
        if (typeForm === 3) {
            setTitleCalification('Historial de Bitácoras')
            return <HistoryBitacora idCustomers={customerSelected.value} />
        }
    }, [typeForm, customerSelected])

    const ensureSelection = () => {
        if (branchOfficeSelected === '') {
            Helpers.toast.construct({ response: 'warning', message: 'Seleccionar Sucursal', toast })
            return false
        }
        if (customerSelected === '') {
            Helpers.toast.construct({ response: 'warning', message: 'Seleccionar Empleado', toast })
            return false
        }
        return true
    }

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Evaluación"
            subtitle="Selecciona sucursal y colaborador para calificar o registrar bitácoras."
        />
        <div className="form-row">
            <div className="col-12 col-md-4">
                <SurfaceCard title="Tipo de Evaluación">
                        <div className="form-row mb-3">
                            <ReactPlaceholder ready={ready} showLoadingAnimation rows={3}>
                                <Select 
                                    text="Sucursal"
                                    options={branchOffices.map(b => {
                                        return {
                                            label: b.name_branch_office,
                                            value: b.id_branch_office,
                                        }
                                    })}
                                    classNameParent="col-12 mb-2"
                                    onChange={e => {
                                        setBranchOfficeSelected(e)
                                        setCustomerSelected('')
                                        setTypeForm(null)
                                    }}
                                />
                            </ReactPlaceholder>
                            <ReactPlaceholder ready={ready} showLoadingAnimation rows={3}>
                                <Select 
                                    text="Empleados"
                                    options={customers.map(b => {
                                        return {
                                            label: b.full_name_cust,
                                            value: b.id_customers,
                                        }
                                    })}
                                    value={customerSelected}
                                    onChange={e => {
                                        setCustomerSelected(e)
                                        setTypeForm(null)
                                    }}
                                />
                            </ReactPlaceholder>
                        </div>
                        <div className="form-row">
                            <div className="col-12 mb-3" onClick={_ => {
                                if (!ensureSelection()) return
                                setTypeForm(1)
                            }}>
                                <div style={actionTile(typeForm === 1)}>
                                    CALIFICAR
                                </div>
                            </div>
                            <div className="col-12 mb-3" onClick={_ => {
                                if (!ensureSelection()) return
                                setTypeForm(2)
                            }}>
                                <div style={actionTile(typeForm === 2)}>
                                    BITÁCORA
                                </div>
                            </div>
                            <div className="col-12 mb-3" onClick={_ => {
                                if (!ensureSelection()) return
                                setTypeForm(3)
                            }}>
                                <div style={actionTile(typeForm === 3)}>
                                    HISTORIAL
                                </div>
                            </div>
                        </div>
                </SurfaceCard>
            </div>
            <div className="col-12 col-md-8 mb-4">
                {typeForm === null ? '' : <SurfaceCard title={titleCalification}>
                        {formAction}
                </SurfaceCard>}
            </div>
        </div>
    </>
}

export default Evaluation
